module.exports = __webpack_public_path__ + "img/logo-light.b8f650de.png";